<faxe-page-layout>
  @if (!viewMode) {
  <mat-accordion>
    <mat-expansion-panel hideToggle #thePanel>
      <mat-expansion-panel-header>
        @if (thePanel.expanded) {
        <mat-icon svgIcon="expand_circle_up"></mat-icon>
        } @if (!thePanel.expanded) {
        <mat-icon svgIcon="expand_circle_down"></mat-icon>
        }
        <mat-panel-title>Visas</mat-panel-title>
        <mat-panel-description>{{
          selectedClassNameList
        }}</mat-panel-description>
      </mat-expansion-panel-header>
      <div class="raceClass">
        <faxe-chip-list
          [preSelectedKeys]="[allClassId]"
          (itemSelectedEvent)="classSelected($event)"
          (itemUnSelectedEvent)="classUnselected($event)"
          (itemPreSelectedEvent)="classPreSelected($event)"
          itemClassDefault="true"
          formCtrlName="raceClass"
          [parentFormGroup]="formGroup"
          [itemsSet]="raceClassDataItem"
        >
        </faxe-chip-list>
      </div>
    </mat-expansion-panel>
    <br />
  </mat-accordion>
  } @if (!riderDataItems || !riderDataItems?.length) {
  <div class="container">
    <mat-progress-bar mode="buffer"></mat-progress-bar>
    <h1 class="wait-text">Inväntar start av klass</h1>
    <img
      class="logga"
      src="./assets/icons/android/android-launchericon-512-512.png"
    />
  </div>
  } @for (rider of riderDataItems; track rider) {
  <mat-card appearance="outlined" class="rider">
    <mat-card-header>
      <img mat-card-avatar [src]="rider?.imageSrc" alt="" />
      <mat-card-title class="card-container-left">{{
        rider.value.riderName
      }}</mat-card-title>
      <mat-card-title class="card-container-right"
        >{{ riderTimeMap?.has(rider.key) ? riderTimeMap.get(rider.key) : '' }}
      </mat-card-title>
      <mat-card-subtitle
        >{{ rider.value.horseCombinationNumber }} - {{ rider.value.horseName }},
        {{ rider.value.clubName }}
      </mat-card-subtitle>
    </mat-card-header>
    <div class="p">
      @for (fenceWithResult of rider.value.fenceWithResult; track
      fenceWithResult) {
      <span
        [ngClass]="{
      'na': fenceWithResult.isFault === undefined,
      'ok': !fenceWithResult.isFault && fenceWithResult.isFault !== undefined,
      'nok': fenceWithResult.isFault,
      }"
      >
      </span>
      }
    </div>
    @if (!viewMode) {
    <div>
      <faxe-collapisble-section
        [collapsed]="isCollapsed(rider.value.riderGuid)"
        (collapsToggle)="handleCollapse($event, rider.value.riderGuid)"
      >
        <faxe-table [data]="tableDataMap.get(rider.value.riderGuid)">
        </faxe-table>
      </faxe-collapisble-section>
    </div>
    }
  </mat-card>
  }
</faxe-page-layout>
